var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17.1943V4.90617C21 4.90617 19.554 3 16.2613 3C14.3075 3 12.4305 3.75948 11.031 5.13849C11.031 5.13849 8.67722 3 5.73866 3C2.8001 3 1 5.04542 1 5.04542C1 5.04542 1.03104 13.0879 1.06137 17.1943C3.0766 15.9546 5.19976 16.0476 5.8614 16.0476C8.44586 16.0476 10.0767 16.8846 11.0458 18C12.0305 16.8689 13.6458 16.0476 16.1076 16.0476C16.8461 16.0633 18.9848 15.9702 21 17.1943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeIcon);
export default __webpack_public_path__ + "static/media/recipe_icon.445fd75be76c81bbf21c68c96580e1fe.svg";
export { ForwardRef as ReactComponent };